import * as yup from 'yup';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';

export const useGlcDetailsValidation = () => {
  const { formatMessage } = useLocale();

  const schema = yup.object().shape({
    nazwa: yup
      .string()
      .max(60, formatMessage({ id: AppMessages['glc.details.validation.name.max'] }))
      .required(formatMessage({ id: AppMessages['common.validation.required'] })),
    opis: yup
      .string()
      .max(60, formatMessage({ id: AppMessages['glc.details.validation.description.max'] }))
      .nullable()
      .optional(),
  });

  return { schema };
};
